module.exports = __webpack_public_path__ + "img/stepchar1.ac70169d.png";